import ReplyRightIcon from '@atlaskit/icon-lab/core/reply-right';
import * as React from 'react';

export function SvgReplyRight() {
  return <ReplyRightIcon label="" testId="ads-refreshed-icon" />;
}
